<template>
  <div class="content-container">
    <filter-location-statuses-data />
    <div class="content-wrap">
      <location-latest-status :location-id="locationId" />
    </div>
  </div>
</template>

<script>
import FilterLocationStatusesData from "@/components/FilterLocationStatusesData.vue";
import LocationLatestStatus from "@/components/LocationLatestStatus.vue";

export default {
  name: "LocationLatestStatusView",
  components: {
    FilterLocationStatusesData,
    LocationLatestStatus,
  },
  computed: {
    locationId() {
      return Number(this.$route.params.id);
    },
  },
};
</script>

<style scoped>
.content-container {
  background-color: var(--surface-secondary);
}
</style>
